<template>
  <div class="honnin-notes edit-item" v-if="editingData">

    <div class="head"><b>本人通知欄<br>（変更内容）</b></div>
    <div class="data">
      <input-textarea v-model="editingData.honnin_notes"
        :error="getError(editingData, 'honnin_notes')"></input-textarea>
      <p class="current-data" v-if="currentData?.honnin_notes" :disabled="disabled">{{ currentData.honnin_notes }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
